import { types } from 'mobx-state-tree';
import Pass from '../passesStore/Pass';

const AccessCode = types.model('AccessCode', {
    access_code_id: types.identifier,
    ticket_id: types.maybeNull(types.string),
    access_token: types.maybeNull(types.string),
    event_id: types.maybeNull(types.number),
    pass_id: types.maybeNull(types.number),
    game_id: types.maybeNull(types.number),
    row_label: types.maybeNull(types.string),
    seat_label: types.maybeNull(types.string),
    block_label: types.maybeNull(types.string),
    // Joined from the game on the API side for the BarCodes dialog. MST drops
    // anything it does not declare, so these have to be listed here.
    opponent: types.maybeNull(types.string),
    opponent_logo: types.maybeNull(types.string),
    game_date: types.maybeNull(types.string),
    away_team: types.maybeNull(types.string),
    start_time: types.maybeNull(types.string),
    pass: types.frozen(Pass),
});

export default AccessCode;
